module.exports = __webpack_public_path__ + "img/yep.7a733118.png";